import './PlaylistGroupList.scss';
import React, { useRef } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import helpers from '../../js/helpers';
import { RESPONSE, ROUTES } from '../../js/_constants';
import ItemCard from '../ItemCard/ItemCard';
import { type PlaylistGroup } from '../../api/types/index';
import { useNavigate } from 'react-router';

type PlaylistGroupListProps = {
    gridStyle: string;
    playlistGroups: PlaylistGroup[];
    label: string;
    totalItems: number;
    tags?: React.ReactNode;
};

const PlaylistGroupList = ({
    gridStyle,
    playlistGroups,
    totalItems,
    tags
}: PlaylistGroupListProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const classes = classNames('b-playlistGroupList', [gridStyle]);

    const ref = useRef(null);

    const renderFooter = (playlistGroup: PlaylistGroup) => (
        <>
            <p className="valid-until">
                {t('playlist_last_edit')}: {helpers.humanDate(playlistGroup.updatedAt) || t('no_data')}
            </p>
        </>
    );

    return (
        <div ref={ref} className={classes}>
            <div className="playlist-groups-result">
                <p>
                    <span className="result" data-testid='playlist-group-result'>{totalItems}</span>
                    {playlistGroups.length > 1
                        ? t('playlist_meets')
                        : t('playlist_meet')}
                </p>
                {tags}
            </div>
            <ul className="playlist-groups-wrapper">
                {playlistGroups.map((playlistGroup, i) => (
                    <ItemCard
                        key={playlistGroup[RESPONSE.ID]}
                        isGridStyle={gridStyle === 'grid'}
                        icon="media-playlist"
                        href={`${ROUTES.PLAYLISTS}/groups/${helpers.getId(playlistGroup)}`}
                        onClick={() =>
                            navigate(`${ROUTES.PLAYLISTS}/groups/${helpers.getId(playlistGroup)}`)
                        }
                        footer={renderFooter(playlistGroup)}
                        title={playlistGroup.title}
                        description={playlistGroup.description}
                        name={'playlist group ' + (i + 1)}
                    />
                ))}
            </ul>
        </div>
    );
};

export default PlaylistGroupList;
